import * as actionTypes from "../action-types";

export const superadminAdminLogin = payload => ({ type: actionTypes.SUPERADMIN_ADMIN_LOGIN, payload });
export const partnerLogin = payload => ({ type: actionTypes.PARTNER_LOGIN, payload });

export const changePassword = payload => ({ type: actionTypes.CHANGE_PASSWORD, payload });
export const logout = payload => ({ type: actionTypes.LOGOUT, payload });

export const superadminAdminForgetPassword = payload => ({ type: actionTypes.SUPERADMIN_ADMIN_FORGET_PASSWORD, payload });
export const partnerForgetPassword = payload => ({ type: actionTypes.PARTNER_FORGET_PASSWORD, payload });
export const resetPassword = payload => ({ type: actionTypes.RESET_PASSWORD, payload });

//* Superadmin-Admin-Partner Details
export const getSuperadminAdminPartnerDetails = payload => ({ type: actionTypes.GET_SUPERADMIN_ADMIN_PARTNER_DETAILS, payload });
export const setSuperadminAdminPartnerDetails = payload => ({ type: actionTypes.SET_SUPERADMIN_ADMIN_PARTNER_DETAILS, payload });